/**
 * Flat, namespaced dictionaries. Keys are `namespace.key` (e.g.
 * "nav.warehouse"). Kept as plain objects (no external i18n library) since
 * the app only needs two static locales — a full i18next setup would be
 * more machinery than this warrants.
 */
export const dictionaries = {
  vi: {
    "common.save": "Lưu",
    "common.cancel": "Hủy",
    "common.create": "Tạo mới",
    "common.edit": "Chỉnh sửa",
    "common.delete": "Xóa",
    "common.search": "Tìm kiếm",
    "common.actions": "Thao tác",
    "common.status": "Trạng thái",
    "common.loading": "Đang tải...",
    "common.saving": "Đang lưu...",
    "common.confirmDeleteTitle": "Xác nhận xóa",
    "common.confirmDeleteDescription": "Hành động này không thể hoàn tác.",
    "common.noResults": "Không có dữ liệu",
    "common.back": "Quay lại",
    "common.viewDetail": "Xem chi tiết",
    "common.export": "Xuất Excel",
    "common.filter": "Bộ lọc",
    "common.all": "Tất cả",
    "common.name": "Tên",
    "common.createdAt": "Ngày tạo",
    "common.updatedAt": "Ngày cập nhật",
    "common.description": "Mô tả",
    "common.note": "Ghi chú",
    "common.required": "Bắt buộc",
    "common.optional": "Tùy chọn",
    "common.next": "Tiếp theo",
    "common.previous": "Quay lại",
    "common.finish": "Hoàn tất",
    "common.total": "Tổng cộng",
    "common.close": "Đóng",

    "nav.general": "Chung",
    "nav.dashboard": "Tổng quan",
    "nav.warehouse": "Kho hàng",
    "nav.warehouseGroup": "KHO HÀNG",
    "nav.products": "Mã máy",
    "nav.accessories": "Phụ kiện",
    "nav.warrantyPackages": "Gói bảo hành",
    "nav.transactionsGroup": "Giao dịch & Khách hàng",
    "nav.transactions": "Giao dịch",
    "nav.clients": "Khách hàng",
    "nav.staff": "Nhân sự",
    "nav.finance": "Tài chính kế toán",
    "nav.statisticsOverview": "Tổng quan cửa hàng",
    "nav.staffPerformance": "KPI & lương nhân viên",
    "nav.inventoryDebt": "Tồn kho & công nợ",
    "nav.system": "Cấu hình hệ thống",
    "nav.configMetadata": "Quản lý metadata",
    "nav.permissionGroups": "Phân quyền",
    "nav.tableColumns": "Quản lý xem bảng",
    "nav.settings": "Cài đặt",

    "auth.signIn": "Đăng nhập",
    "auth.email": "Email",
    "auth.password": "Mật khẩu",
    "auth.signInCta": "Đăng nhập",
    "auth.signInDescription": "Đăng nhập để quản lý cửa hàng GHz.",
    "auth.profile": "Thông tin tài khoản",
    "auth.logout": "Đăng xuất",
  },
  en: {
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.create": "Create",
    "common.edit": "Edit",
    "common.delete": "Delete",
    "common.search": "Search",
    "common.actions": "Actions",
    "common.status": "Status",
    "common.loading": "Loading...",
    "common.saving": "Saving...",
    "common.confirmDeleteTitle": "Confirm delete",
    "common.confirmDeleteDescription": "This action cannot be undone.",
    "common.noResults": "No data",
    "common.back": "Back",
    "common.viewDetail": "View detail",
    "common.export": "Export Excel",
    "common.filter": "Filter",
    "common.all": "All",
    "common.name": "Name",
    "common.createdAt": "Created",
    "common.updatedAt": "Updated",
    "common.description": "Description",
    "common.note": "Note",
    "common.required": "Required",
    "common.optional": "Optional",
    "common.next": "Next",
    "common.previous": "Previous",
    "common.finish": "Finish",
    "common.total": "Total",
    "common.close": "Close",

    "nav.general": "General",
    "nav.dashboard": "Dashboard",
    "nav.warehouse": "Warehouse",
    "nav.warehouseGroup": "WAREHOUSE",
    "nav.products": "Devices",
    "nav.accessories": "Accessories",
    "nav.warrantyPackages": "Warranty packages",
    "nav.transactionsGroup": "Transactions & Clients",
    "nav.transactions": "Transactions",
    "nav.clients": "Clients",
    "nav.staff": "Personnel",
    "nav.finance": "Finance & accounting",
    "nav.statisticsOverview": "Store overview",
    "nav.staffPerformance": "Staff KPI & payroll",
    "nav.inventoryDebt": "Inventory & receivables",
    "nav.system": "System settings",
    "nav.configMetadata": "Metadata management",
    "nav.permissionGroups": "Permission groups",
    "nav.tableColumns": "Table columns",
    "nav.settings": "Settings",

    "auth.signIn": "Sign in",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signInCta": "Sign in",
    "auth.signInDescription": "Sign in to manage the GHz store.",
    "auth.profile": "Profile",
    "auth.logout": "Log out",
  },
} as const;

export type Locale = keyof typeof dictionaries;
export type TranslationKey = keyof (typeof dictionaries)["vi"];
